<template>
  <container-list-extend
    title="Commande"
    :class="{ 'commande-annulee': commande.etat_id === 9 }"
  >
    <template v-slot:title>
      <UserViewer :userId="commande.user_id" class></UserViewer>
      <div
        class="p-1 rounded-top d-flex flex-row align-items-center flex-grow-1"
      >
        <span class="ml-3 text-muted">Commande N°{{ commande.id }}</span>
      </div>
      <div
        class="text-muted pl-2 pr-2 pl-md-3 pr-md-3 d-flex align-items-center"
      >
        <small>
          <description-from-list
            :value="commande.etat_id"
            :data="data.etats"
            text="à saisir"
          ></description-from-list>
        </small>
      </div>
    </template>
    <template v-slot:form>
      <div class="pl-3 pr-3 mt-3">
        <button
          class="btn btn-outline-primary mr-2"
          :class="{ active: activeTab == 2 }"
          @click="activeTab = 2"
        >
          Commande
        </button>
        <button
          class="btn btn-outline-primary mr-2"
          :class="{ active: activeTab == 3 }"
          @click="activeTab = 3"
        >
          Livraison
        </button>
        <button
          class="btn btn-outline-primary"
          :class="{ active: activeTab == 4 }"
          @click="activeTab = 4"
        >
          Contrôle
        </button>
      </div>
      <div class="p-3">
        <div
          v-if="activeTab !== 1 && commande.societe_facturation_id"
          class="text-muted"
        >
          Société :
          <description-from-list
            :value="commande.societe_facturation_id"
            :data="data.societes"
            text="à saisir"
          ></description-from-list>
        </div>
        <div
          v-if="activeTab !== 1 && commande.contact_livraison"
          class="text-muted"
        >
          Contact pour la livraison :
          {{ commande.contact_livraison }}
        </div>
        <div
          v-if="activeTab !== 1 && commande.adresse_livraison"
          class="text-muted"
        >
          Adresse de livraison :
          {{ commande.adresse_livraison }}
        </div>
        <div
          v-if="activeTab !== 1"
          class="text-muted d-flex justify-content-between align-items-center"
        >
          <span v-if="commande.commentaire">
            Commentaire du demandeur :
            {{ commande.commentaire }}
          </span>
          <button
            class="btn btn-sm btn-outline-primary"
            @click="isEditingComment = true"
            v-if="!isEditingComment"
          >
            {{
              commande.commentaire
                ? "Modifier le commentaire"
                : "Ajouter un commentaire"
            }}
          </button>
        </div>

        <!-- Champ d'édition du commentaire (conditionnel) -->
        <div class="mt-3" v-if="isEditingComment">
          <label class="form-label">Commentaire :</label>
          <div class="d-flex">
            <textarea
              class="form-control mr-2"
              rows="3"
              v-model="editableCommentaire"
              placeholder="Saisissez votre commentaire..."
            ></textarea>
            <div class="d-flex flex-column">
              <button
                class="btn btn-primary mb-2"
                @click="updateCommandeCommentaire"
                :disabled="loading"
              >
                {{ loading ? "Enregistrement..." : "Enregistrer" }}
              </button>
              <button
                class="btn btn-secondary"
                @click="cancelEditComment"
                :disabled="loading"
              >
                Annuler
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-3" v-if="activeTab == 2">
        <trame-uploader
          id="document_materiel_commande_trame"
          :file_system="'MATERIELS'"
          title="Exportez le bon de commande"
          :data="BdcData"
          :shadow="false"
          class="m-0 p-0"
        ></trame-uploader>
      </div>
      <div class="mt-3" v-if="activeTab > 2">
        <task-manager
          class="mt-3 mb-3"
          :id="commande.id"
          system="commande_materiel"
        ></task-manager>

        <task-manager
          class="mt-3 mb-3"
          :id="commande.id"
          :title="'Tâches à réaliser spécifiques à cette commande'"
          :system="`commande_materiel_${commande.id}`"
        ></task-manager>

        <uploader
          v-if="commande.id"
          id="document_materiel_commande"
          url="/upload/document"
          title="Vos fichiers"
          :file_system="'MATERIEL/commandes'"
          :file_field="'commande'"
          :file_key="commande.id"
          class="p-3 rounded"
        ></uploader>
      </div>
      <div class="d-flex p-3">
        <button class="btn btn-danger" @click="deleteCommande(commande)">
          Supprimer
        </button>
        <button
          v-if="commande.etat_id != 9"
          class="btn btn-danger ml-2"
          @click="cancelCommande(commande)"
        >
          Annuler la commande
        </button>

        <button
          v-if="commande.etat_id == 9"
          class="btn btn-outline-primary ml-2"
          @click="updateCommandeEtat(2)"
        >
          Restaurer la commande
        </button>

        <button
          class="btn btn-primary ml-2"
          v-if="commande.etat_id == 1"
          @click="updateCommandeEtat(2)"
        >
          valider la demande
        </button>
        <button
          class="btn btn-primary ml-2"
          v-if="commande.etat_id == 2"
          @click="updateCommandeEtat(3)"
        >
          valider la commande
        </button>
        <button
          class="btn btn-primary ml-2"
          v-if="commande.etat_id == 3"
          @click="updateCommandeEtat(4)"
        >
          valider la réception
        </button>

        <!-- Select pour changer l'état -->
        <div class="ml-auto d-flex align-items-center">
          <select
            class="form-control mr-2"
            style="width: auto;"
            v-model="selectedEtatId"
            :disabled="commande.etat_id == 9"
          >
            <option value="" disabled selected>Changer l'état</option>
            <option
              v-for="etat in data.etats"
              :key="etat.id"
              :value="etat.id"
              :disabled="etat.id == commande.etat_id"
            >
              {{ etat.description }}
            </option>
          </select>
          <button
            class="btn btn-success"
            @click="updateCommandeEtat(selectedEtatId)"
            :disabled="!selectedEtatId || selectedEtatId == commande.etat_id"
          >
            OK
          </button>
        </div>
      </div>
    </template>
    <template v-slot:actions>
      <CommandesItemArticles :commande="commande"></CommandesItemArticles>
    </template>
  </container-list-extend>
</template>
<script>
import { mapActions } from "vuex";
import { errHandler } from "@/helpers.js";
import { mapGetters } from "vuex";

import ContainerListExtend from "@/components/containers/ContainerListExtend.vue";
import DescriptionFromList from "@/components/bases/DescriptionFromList";
import CommandesItemArticles from "@/components/materiels/CommandesItemArticles";
import UserViewer from "@/components/application/UserViewer";
import TrameUploader from "@/components/application/TrameUploader.vue";
import Uploader from "@/components/bases/Uploader.vue";
import TaskManager from "@/components/application/TasksManager.vue";

export default {
  name: "CommandesItem",
  components: {
    ContainerListExtend,
    DescriptionFromList,
    CommandesItemArticles,
    UserViewer,
    TrameUploader,
    Uploader,
    TaskManager
  },

  data() {
    return {
      feedback: {},
      loading: false,
      statut: null,
      selectedEtatId: null,
      activeTab: 1, // Onglet actif (1=Demande, 2=Commande, 3=Livraison, 4=Contrôle)
      editableCommentaire: "", // Commentaire éditable
      isEditingComment: false // Mode édition du commentaire
    };
  },
  props: ["commande"],
  mounted() {
    console.log(this.data.etats);
    // Initialiser l'onglet actif selon l'état actuel de la commande
    this.activeTab = this.commande.etat_id;
    // Initialiser le commentaire éditable avec le commentaire existant
    this.editableCommentaire = this.commande.commentaire || "";
  },
  computed: {
    ...mapGetters({
      data: "materiel/data",
      commandeArticles: "materiel/commandeArticles",
      articles: "materiel/articles"
    }),
    BdcData: function() {
      // DATA
      let data = this.commandeArticles;
      let articles = [];
      let totalHT = 0;

      if (!data) return [];

      data.forEach(cmdArticle => {
        if (
          cmdArticle.commande_id == this.commande.id &&
          cmdArticle.quantite_commande > 0
        ) {
          const desc = this.articleById(cmdArticle.article_id).description;
          const prix_unitaire = this.articleById(cmdArticle.article_id)
            .prix_unitaire_ht;
          const quantite = cmdArticle.quantite_commande;
          const prix =
            cmdArticle.quantite_commande *
            this.articleById(cmdArticle.article_id).prix_unitaire_ht;
          totalHT = totalHT + prix;
          articles.push([desc, prix_unitaire, quantite, prix.toFixed(2)]);
        }
      });

      return {
        values: {
          num: this.commande.id,
          date: this.$moment().format("DD/MM/YYYY"),
          totalHT: totalHT,
          totalTTC: totalHT * 1.2,
          totalTVA: totalHT * 0.2
        },
        tablesSize: 9,
        tables: [
          {
            key: "tableau_articles",
            data: {
              header: [
                { id: 1, text: "Description" },
                { id: 1, text: "Prix unitaire" },
                { id: 2, text: "Quantité" },
                { id: 3, text: "Prix" }
              ],
              body: articles
            }
          }
        ],
        images: []
      };
    }
  },
  methods: {
    ...mapActions({
      _updateCommande: "materiel/updateCommande",
      _deleteCommande: "materiel/deleteCommande",
      _cancelCommande: "materiel/cancelCommande"
    }),
    updateCommande(commande) {
      this.feedback = {};
      this.loading = true;
      this._updateCommande(commande)
        .catch(error => (this.feedback = errHandler(error)))
        .finally(() => (this.loading = false));
    },
    deleteCommande(commande) {
      if (!window.confirm("Confirmer la suppression de la commande ?"))
        return null;
      this.feedback = {};
      this.loading = true;
      this._deleteCommande(commande)
        .catch(error => (this.feedback = errHandler(error)))
        .finally(() => (this.loading = false));
    },
    cancelCommande() {
      if (
        !window.confirm(
          "Confirmer l'annulation de la commande ? Il existera toujours dans la liste mais ne sera plus actif."
        )
      )
        return null;
      this.feedback = {};
      this.loading = true;
      this.commande.etat_id = 9; // Annulé
      this.updateCommande(this.commande);
    },
    updateCommandeEtat(etat_id) {
      this.commande.etat_id = etat_id;
      this.updateCommande(this.commande);
      // Réinitialiser le select après la mise à jour
      this.selectedEtatId = null;
    },

    updateCommandeCommentaire() {
      this.commande.commentaire = this.editableCommentaire;
      this.updateCommande(this.commande);
      // Fermer le mode édition après sauvegarde
      this.isEditingComment = false;
    },

    cancelEditComment() {
      // Remettre la valeur originale et fermer le mode édition
      this.editableCommentaire = this.commande.commentaire || "";
      this.isEditingComment = false;
    },

    articleById(id) {
      return this.articles.filter(art => art.id == id)[0];
    }
  }
};
</script>
<style lang="css">
.commande-annulee {
  background-color: #f8d7da !important; /* Rouge clair */
  border: 2px solid #dc3545 !important; /* Bordure rouge */
  border-radius: 8px !important;
  opacity: 0.9;
}

.commande-annulee > div,
.commande-annulee > div > div {
  background-color: #f8d7da !important;
}

.commande-annulee .card,
.commande-annulee .container-list-extend {
  background-color: #e93a49 !important;
}

.commande-annulee .card-header {
  background-color: #c42f3e !important;
  border-bottom: 1px solid #dc3545 !important;
}
</style>
